import { render, staticRenderFns } from "./FooterColumn.vue?vue&type=template&id=fe894efe&lang=pug&"
import script from "./FooterColumn.vue?vue&type=script&lang=js&"
export * from "./FooterColumn.vue?vue&type=script&lang=js&"
import style0 from "./FooterColumn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe894efe')) {
      api.createRecord('fe894efe', component.options)
    } else {
      api.reload('fe894efe', component.options)
    }
    module.hot.accept("./FooterColumn.vue?vue&type=template&id=fe894efe&lang=pug&", function () {
      api.rerender('fe894efe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FooterColumn.vue"
export default component.exports